<template>
    <div class="result-pie">
        <Echart ref="echart" :initOptions="pieInitOptions"></Echart>
        <div class="catagory" :class="{ center: catagory.length === 1 }">
            <div class="catagory-item" v-for="item in catagory" :key="item.key">
                <div
                    class="mark"
                    :style="{ backgroundColor: item.color }"
                ></div>
                <span class="catagory-title">{{ item.name }}</span>
                <span class="catagory-price">
                    {{ getCatagoryPrice(item.value) }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';
import Echart from '../../components/echart.vue';
import showPieStyle from '../../components/caculator/lib/drawChart';
import util from '../../common/util.js';
export default {
    components: { Echart },
    props: {
        theme: {
            type: String,
            default: 'template1'
        }
    },
    // i18next: {
    //     translationResourcesLoaded() {
    //         this.$nextTick(this.refresh);
    //     }
    // },
    data: function() {
        return {
            pieInitOptions: null,
            catagory: [],
            resourceData: {}
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            currencySymbol: store => store.currency?.symbol
        }),
        isMobileSize() {
            return this.platform.isMobile;
        }
    },
    beforeMount() {
        this.onLngNsLoaded('common').then(() => {
            this.refresh();
        });
    },
    methods: {
        refresh(data) {
            if (data) {
                this.resourceData = data;
            }
            if (!util.isSSRServer) {
                let res = showPieStyle.call(
                    this,
                    this.resourceData,
                    this.theme,
                    this.currencySymbol
                );
                let formatter = res.chartOption?.series[0]?.label?.formatter;
                // md-calculator Do not do currency internationalization
                if (typeof formatter === 'function') {
                    res.chartOption.series[0].label.formatter = function(
                        param
                    ) {
                        param.noNeedCurreny = true;
                        return formatter.call(null, param);
                    };
                }

                if (this.theme === 'broker') {
                    Object.assign(res.chartOption.series[0].label, {
                        show: true
                    });
                    Object.assign(
                        res.chartOption.series[0].label.rich.a,
                        this.isMobileSize
                            ? {
                                color: '#191919',
                                fontSize: 16,
                                fontFamily: 'font-bold',
                                lineHeight: 19,
                                marginBottom: 1
                            }
                            : {
                                color: '#191919',
                                fontSize: 24,
                                fontFamily: 'font-bold',
                                lineHeight: 40,
                                marginBottom: 8
                            }
                    );
                }
                this.pieInitOptions = res.chartOption;
                if (!this.$refs.echart) {
                    return;
                }
                if (this.$refs.echart.echart) {
                    this.$refs.echart.echart.dispose();
                }
                this.$refs.echart.init();

                this.catagory = res.calResult;
            }
        },
        getCatagoryPrice(price) {
            return this.$ft.formatDollar(price, true, false, '$0');
        }
    }
};
</script>
<style lang="scss">
@import '../../theme/media.scss';
.md-calculator {
    .result-pie {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .catagory {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            margin-top: 30px;
            .catagory-item {
                width: calc(55% - 5px);
                flex: 1 1 auto;
                margin-bottom: 12px;
                display: flex;
                margin-right: 10px;
                flex-wrap: wrap;
                position: relative;
                padding-left: 30px;
                word-break: break-word;

                &:nth-child(2n) {
                    margin-right: 0px;
                    width: calc(45% - 5px);
                    padding-left: 20px;
                    .mark {
                        left: 0px;
                    }
                }
                .mark {
                    width: 12px;
                    height: 12px;
                    position: absolute;
                    top: 2px;
                    left: 10px;
                }
                .catagory-title {
                    font-family: var(--font-light);
                    font-size: 14px;
                    color: #202437;
                    margin-right: 4px;
                    flex: 0 0 auto;
                    margin-right: 10px;
                }
                .catagory-price {
                    font-size: 14px;
                    font-family: var(--font-bold);
                    color: #464646;
                    white-space: nowrap;
                }
            }
            &.center {
                justify-content: center;
                .catagory-item {
                    max-width: fit-content;
                }
            }
        }
        &.single {
            .catagory {
                .catagory-item {
                    padding-left: 30px;
                    &:nth-child(2n) {
                        padding-left: 30px;
                        .mark {
                            left: 10px;
                        }
                    }
                }
            }
        }
    }
}
@include media-600 {
    .md-calculator {
        .result-pie {
            .catagory {
                width: 100%;
                .catagory-item {
                    width: 85%;
                    margin-right: 0px;
                    flex: none;
                    margin-right: auto;
                    margin-left: auto;
                    justify-content: space-between;
                    &:nth-child(2n) {
                        margin-right: auto;
                        width: 85%;
                        padding-left: 30px;
                        .mark {
                            left: 10px;
                        }
                    }
                }
            }
        }
    }
}
</style>
